import { GET_ACCOUNT_JOURNAL, GET_ACCOUNT_JOURNAL_SUMMARY } from "src/actions/accountDetailsActions/accountJournal.actions";

let initialState = {
  accountJournalInformation: {},
  accountJournalSummary: {},
  loading: false,
  summaryLoading: false,
  error: null,
  summaryError: null
};

export const accountJournalReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACCOUNT_JOURNAL.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_ACCOUNT_JOURNAL.SUCCESS:
      return {
        ...state,
        accountJournalInformation: action.payload,
        loading: false,
        error: null
      };
    case GET_ACCOUNT_JOURNAL.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case GET_ACCOUNT_JOURNAL_SUMMARY.REQUEST:
      return {
        ...state,
        summaryLoading: true,
        summaryError: null
      };
    case GET_ACCOUNT_JOURNAL_SUMMARY.SUCCESS:
      return {
        ...state,
        accountJournalSummary: action.payload,
        summaryLoading: false,
        summaryError: null
      };
    case GET_ACCOUNT_JOURNAL_SUMMARY.FAILURE:
      return {
        ...state,
        summaryLoading: false,
        summaryError: action.error
      };
    default:
      return state;
  }
};
